export enum TypeOrderEnum {
  MARKET = 'Market',
  LIMITED = 'Limited',
  STOP = 'Stop',
  STOP_LOSS = 'Stop Loss',
  STOP_LIMIT = 'Stop Limit',
  START = 'Start',
  MARKETPROTECTED = 'MarketProtected'
  // ONCLOSE = 5 ?
}
